<div id="overlay" *ngIf="state">
    <span class="loader"></span>
    <div class="loading-text">{{stateText ? stateText : 'Loading...'}}</div>
</div>
